function LinkBigIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="182"
      height="79"
      viewBox="0 0 182 79"
      fill="none"
    >
      <path
        d="M100.713 44.8958L98.5542 42.7374L100.713 40.5791C103.693 37.5991 103.693 32.7675 100.713 29.7874C97.7325 26.8073 92.9009 26.8073 89.9208 29.7874L87.7625 31.9458L85.6041 29.7874L87.7625 27.6291C91.9347 23.457 98.6989 23.457 102.871 27.6291C107.043 31.8011 107.043 38.5655 102.871 42.7374L100.713 44.8958ZM96.3959 49.2126L94.2375 51.3709C90.0655 55.543 83.3012 55.543 79.1291 51.3709C74.957 47.1988 74.957 40.4346 79.1291 36.2624L81.2874 34.1041L83.4458 36.2624L81.2874 38.4208C78.3074 41.4008 78.3074 46.2326 81.2874 49.2126C84.2675 52.1926 89.0992 52.1926 92.0792 49.2126L94.2375 47.0543L96.3959 49.2126ZM95.3167 33.0249L97.475 35.1833L86.6833 45.9751L84.525 43.8166L95.3167 33.0249Z"
        fill="#8E8E8E"
        fillOpacity="0.8"
      />
    </svg>
  );
}

export default LinkBigIcon;
